export interface BorrowAmountClassNames {
  container: string;
  heading: string;
  fieldWrapper: string;
  field: string;
  button: string;
  displayLoan: string;
  input: string;
  warning: string;
}

export const CLASS_NAMES: BorrowAmountClassNames = {
  container: 'w-full flex flex-col',
  heading: 'text-14-22-em text-neutral-600 mb-2 min-w-30',
  fieldWrapper: 'flex flex-row w-full mb-2',
  field: 'my-auto -mb-5 max-w-40',
  button: 'flex flex-row py-1.75',
  displayLoan: 'text-16-20-em text-purple-500 my-auto mr-3',
  input: 'flex flex-row items-center justify-start gap-x-2',
  warning: 'text-lavender-200 text-14-22-em block -mt-2 mb-4',
};

export const ICON_PROPS = {
  icon: 'edit',
  stroke: 'purple-500',
  size: 16,
  className: 'my-auto',
};
